import ListBanners from './ListBanners';

export default ListBanners;
